import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { DashboardItemDescriptor } from './model/dashboard.item';

class GetDashboardItemsRequest {
  
}

class GetDashboardItemsResponse {
  dashboardItems: DashboardItemDescriptor[];
}

class GetDashboardItemDataRequest {
  dashboardItemId: string;
  filters: string[];
}

class GetDashboardItemDataResponse {
  json: string;
}

@Injectable()
export class DashboardService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'dashboard',
      authService,
      config.BFFSConfig
    );
  }

  public async getDashboardItems(): Promise<DashboardItemDescriptor[]> {
    return (await super.post<GetDashboardItemsResponse>({ }, null, "getdashboarditems")).dashboardItems;
  }

  public async getDashboardItemData(dashboardItemId: string, filters: string[]): Promise<string> {
    return (await super.post<GetDashboardItemDataResponse>({ dashboardItemId, filters }, null, "getdashboarditemdata")).json;
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.service.ts